// src/redux/actions/Settings.js
export const SET_SETTINGS = "SET_SETTINGS";

export const setSettings = (locale, direction) => ({
  type: SET_SETTINGS,
  payload: { locale, direction },
});
